import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { nativeInvoicePayResponseSchema } from "../schemas/domains/invoice/native-invoice-pay.schema";

const c = initContract();

// Public, unauthenticated lookup by `paymentToken` only. The token is an
// unguessable uuidv7 minted when collect-payment is enabled — never the
// invoice id. The SPA redirects to `checkoutUrl` when set, otherwise renders a
// status screen. Unknown tokens return 404.
export const nativeInvoicePayContract = c.router(
    {
        getPaymentPage: {
            method: "GET",
            path: "/:paymentToken",
            responses: {
                200: nativeInvoicePayResponseSchema,
                404: c.type<object>(),
            },
            pathParams: z.object({
                paymentToken: z.string().uuid(),
            }),
        },
    },
    {
        pathPrefix: "/native-invoice-pay",
    },
);
